// Ensure global is defined
window.global ||= window;

// Initialize AWS SDK if needed
if (!window.AWS) {
  console.warn('AWS SDK not found, initializing empty object');
  window.AWS = {};
}

// Initialize LexWebUi global object if needed
if (!window.LexWebUi) {
  console.warn('LexWebUi not found, initializing empty object');
  window.LexWebUi = {};
}